import {
  VectorStyleLayer,
  VectorStyle
} from '../../../../../layer-type-services/vector-tile/twc-vector-tile.layer';
import { TwcProduct } from '../../../../../twc-products';

const TEMPS_ALOFT_VECTOR_STYLE_LAYERS: VectorStyleLayer[] = [
  {
    layout: {
      'text-field': ['get', 'temperatureIsobaric'],
      'text-size': 10,
      'text-padding': 40,
      'text-anchor': 'bottom-left',
      'icon-allow-overlap': true
    },
    paint: {
      'text-halo-color': '#000000',
      'text-halo-width': 2,
      'text-color': '#ffffff'
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'temps-aloft',
    filter: ['has', 'temperatureIsobaric'],
    type: 'symbol',
    maxzoom: 28
  }
];

export const TEMPS_ALOFT_VECTOR_STYLE: VectorStyle = {
  layers: TEMPS_ALOFT_VECTOR_STYLE_LAYERS,
  glyphs: `assets/weather/glyphs/Font11_Regular/0-255.pbf`
};
export const TEMPS_ALOFT_PRODUCT_DATA: TwcProduct = {
  id: 'temps-aloft',
  defaultProductId: '1214',
  productName: 'Weather-TempsAloft-TWC',
  label: 'Temps Aloft',
  weatherType: 'TEMPS_ALOFT',
  description: 'TWC product (vector, forecast) - Temps Aloft Forecast',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 360,
  lodMax: 3,
  protocol: 'VectorTile',
  forecastTimeSlicePeriod: 360,
  flightLevelProductIds: {
    FL050: '1210',
    FL100: '1211',
    FL140: '1212',
    FL180: '1213',
    FL240: '1214',
    FL300: '1215',
    FL340: '1216',
    FL390: '1217',
    FL450: '1218',
    FL530: '1219'
  },
  zOrder: 90,
  layerSpecs: {
    vectorTile: { vectorStyle: TEMPS_ALOFT_VECTOR_STYLE }
  }
};
